import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { store } from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'BlockCookiePolicy',
  setup(__props) {

const cookieScriptTag = ref(null);
const selectedLanguage = computed<any>(() => store.getters['app/selectedLanguage']);

onMounted(() => {
    setCookieScriptTag();
});

function setCookieScriptTag() {
    let language = selectedLanguage.value.code;
    if (language.split('-').length === 2) {
        language = language.substring(0, 2).toUpperCase();
    }

    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = 'https://consent.cookiebot.com/e845ff83-85f2-47ba-8102-5cef11f28a1c/cd.js';
    scriptElement.setAttribute('data-culture', language);
    scriptElement.setAttribute('id', 'CookieDeclaration');
    cookieScriptTag.value.appendChild(scriptElement);
}

return { __sfc: true,cookieScriptTag, selectedLanguage, setCookieScriptTag }
}

})